import React, { useCallback } from 'react';
import { formatDateTime } from 'utils/date';
import { copyRowIdShortcut } from 'utils/keyboardShortcuts';

import { LinkIcon } from '@fragment/ui/src/components/Icon/LinkIcon/LinkIcon';
import { IdCopyButton } from '@fragment/ui/src/components/IdCopyButton';
import type { ColumnDefinition } from '@fragment/ui/src/components/Table';
import { NavTable } from '@fragment/ui/src/components/Table/NavTable';
import { TableHoverDetailRow } from '@fragment/ui/src/components/TableHoverDetailRow/TableHoverDetailRow';

import type { LinkNode } from './types';

const emptyValue = {
  Name: 'No Links Yet',
  Created: 'N/A',
};

export const generatePath = (id: string) =>
  `/links/id/${encodeURIComponent(id)}`;

const schema: ColumnDefinition<LinkNode>[] = [
  {
    title: 'Name',
    colspan: 'col-span-2',
    format: (row: LinkNode) => (
      <TableHoverDetailRow
        detail={<IdCopyButton type="id" identifier={row.id} />}
      >
        <div className="flex items-center flex-shrink-0">
          <LinkIcon type={row.__typename} />
        </div>
        <div className="truncate ml-[2px]">{row.name}</div>
      </TableHoverDetailRow>
    ),
  },
  {
    title: 'Created',
    justify: 'right',
    format: (row: LinkNode) => <span>{formatDateTime(row.created)}</span>,
  },
];

type Props = {
  data: LinkNode[];
};

export const LinksTable = ({ data }: Props): JSX.Element => {
  const getPath = useCallback((link: LinkNode) => generatePath(link.id), []);
  return (
    <NavTable
      textSize="md"
      keyboardShortcuts={copyRowIdShortcut}
      {...{ data, emptyValue, getPath, schema }}
      dottedHeader={false}
      borderedRows
    />
  );
};
